import { FC } from 'react';
import { Container, Col, Row } from 'react-bootstrap';

import FormLogoHeader from '../FormLogoHeader/FormLogoHeader';
import LoginFormHeader from '../LoginFormHeader/LoginFormHeader';
import { ImageURLs } from '../../../utils/constants';

import './UnauthenticatedWrapper.scss';

interface IProps {
  formName: string;
}

const UnauthenticatedWrapper: FC<IProps> = ({ formName, children }) => {
  return (
    <div className="UnauthenticatedWrapper d-flex w-100 vh-100">
      {/* Left Content */}
      <div className="UnauthenticatedWrapper-form">
        <Container fluid className="UnauthenticatedWrapper-form-container d-flex flex-column">
          <FormLogoHeader />
          <Row className="mt-3">
            <Col
              xs={{ span: 10, offset: 1 }}
              sm={{ span: 10, offset: 1 }}
              md={{ span: 10, offset: 1 }}
              lg={{ span: 8, offset: 2 }}
              xl={{ span: 6, offset: 3 }}
            >
              <LoginFormHeader formName={formName} />
              {children}
            </Col>
          </Row>
          <Row className="login-footer mt-auto">
            <Col className="p-4">
              <div className="text">All Rights Reserved to Praktio LLC</div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Right Content */}
      <div className="UnauthenticatedWrapper-image d-none d-md-flex h-100">
        <img src={ImageURLs.loginImage} alt="Praktio Characters" data-testid="right-img" />
      </div>
    </div>
  );
};

export default UnauthenticatedWrapper;
